import { useFlags } from 'launchdarkly-react-client-sdk';
import { Outlet } from 'react-router-dom';

import type { LdFeatureFlags } from '@/config/features';
import { useUserAttributes } from '@/hooks/queries/use-user-attributes';
import type { OrArray } from '@/types/generics';
import type { UserSegment } from '@/types/user';
import LoadingPage from './loading';
import UserSegmentRedirect from './user-segment-redirect';

const UserSegmentGuard = ({ segment }: { segment: OrArray<UserSegment> }) => {
  const { isLoading, data: userAttributes } = useUserAttributes();
  const { institutionalOnboardingEnabled } = useFlags<LdFeatureFlags>();
  const { segment: userSegment } = userAttributes ?? {};
  const segments = Array.isArray(segment) ? segment : [segment];

  // If the institutional onboarding flag is disabled, don't check the user segment (preserving the existing behaviour)
  if (!institutionalOnboardingEnabled) {
    return <Outlet />;
  }

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!userSegment) {
    throw new Error('User segment is not set');
  }

  if (!segments.includes(userSegment)) {
    return <UserSegmentRedirect />;
  }

  return <Outlet />;
};
UserSegmentGuard.displayName = 'UserSegmentGuard';

export default UserSegmentGuard;
